import { dynamicschemaData } from "../models/dynamic-schema-data";
import { Injectable } from '@angular/core';


@Injectable()
export class TemplateService {
  public getTemplate() {
    const template = new dynamicschemaData();
    return template;
  }

  public getTemplateText() {
    const template = new dynamicschemaData();
    return JSON.stringify(template.fields);
  }

}
